import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import { subscriptionToolId } from '@/consts/configs';

const openOfferScreen = (toolId?: string): void => {
  getContext()
    .handlers.openOfferScreen({
      touchpoint: 'preset-gen-generic',
      entryPoint: toolId ?? subscriptionToolId,
    })
    .catch((error: unknown) =>
      errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN)
    );
};

export default openOfferScreen;
